import React from 'react';
import * as FormComponents from '../../../../Form';
import { IWorkspaceItem } from '../../../../../redux/slices/workspaces';
import ReactSelectMenu from '../../../../Dropdown/StyledReactSelect/ReactSelectMenu';

interface IProps {
  availableWorkspaces: IWorkspaceItem[];
  onWorkspaceSelect: (workspace: IWorkspaceItem | null) => void;
  isWorkspacesListLoading: boolean;
  searchString: string;
  onSearchChange: (searchString: string) => void;
}

interface IWorkspaceOption {
  template: IWorkspaceItem;
  value: IWorkspaceItem['id'];
  label: IWorkspaceItem['name'];
}

export default ({
  availableWorkspaces,
  onWorkspaceSelect,
  isWorkspacesListLoading,
  searchString,
  onSearchChange,
}: IProps) => {
  const handleChange = (selectedOption: IWorkspaceOption | null) => {
    onWorkspaceSelect(selectedOption?.template ?? null);
  };

  return (
    <FormComponents.VerticalField>
      <FormComponents.FieldLabel>Workspace name</FormComponents.FieldLabel>
      <ReactSelectMenu
        placeholder="Select an existing workspace"
        options={
          availableWorkspaces?.map((template) => ({
            template,
            value: template.id,
            label: template.name,
          })) ?? []
        }
        onChange={handleChange}
        isLoading={isWorkspacesListLoading}
        isSearchable
        inputValue={searchString}
        onInputChange={onSearchChange}
      />
    </FormComponents.VerticalField>
  );
};
